import _ from 'lodash-es';
import { Formio, Components } from 'formiojs';

import PhoneInput from "./PhoneInput";

const FieldComp = Components.components.field;

export default class IntlPhone extends FieldComp {

    constructor(component, options, data) {
        super(component, options, data);

        if (component.key !== "defaultValue") {
            this.phoneInput = new PhoneInput({
                country: 'us',
                id: component.id,
                key: component.key,
                enableTerritories: true,
                placeholder: component.placeholder,
                priority: {'us': 1},
                value: _.get(data, component["key"])
            });
        }
    }

    /**
     * This function is the default settings for the component. At a minimum you want to set the type to the registered
     * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
     *
     * @param sources
     * @returns {*}
     */
    static schema() {
        return FieldComp.schema(_.assignIn(PhoneInput.props, {
            type: "intlPhoneComp",
            label: "Phone Number",
            country: 'us'
        }));
    }

    /**
     * This function tells the form builder about your component. It's name, icon and what group it should be in.
     *
     * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
     */
    static builderInfo = {
        title: "Intl Phone Number",
        icon: "globe",
        group: "VSee Clinic",
        documentation: "",
        weight: -10,
        schema: IntlPhone.schema()
    };

    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     *
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        if (this.phoneInput) {
            this.phoneInput.attachEvents(element, (type, d) => {
                if (type === "setValue") {
                    this.setValue(d, {
                        changed: true
                    });
                }
            });
        }
        return super.attach(element);
    }

    detach() {
        if (this.phoneInput) {
            this.phoneInput.removeEvents();
        }
        return super.detach();
    }

    destroy() {
        return super.destroy();
    }

    getValue() {
        return this.phoneInput.state.formattedNumber;
    }

    render(children) {
        if (!this.phoneInput) {
            return super.render();
        }
        return super.render(this.phoneInput.render());
    }
}

Formio.use({
    components: {
        intlPhoneComp: IntlPhone
    }
});
